<template>
    <v-card>
        <v-card-title class="pb-0 pt-1" >
            <v-icon style="background: #e7e8e9; padding: 10px!important; border-radius: 50%;" class="mr-4">mdi-file-document-outline</v-icon>
            <span >Nueva {{quole}}</span>
            <v-spacer></v-spacer>
            <v-col cols="12" sm="6" md="3">
                <v-autocomplete  :rules="[v => !!v || 'Campo requerido']" v-if="permissions('assignQuotations')" clearable v-model="quotation.user_id" :items="usersLists" label="Vendedor" item-text="name" item-value="id">
                    <template slot="no-data" class="pa-2">No existen usuarios relacionados.</template>                      
                </v-autocomplete>
                <v-autocomplete v-else-if="quotation.user_id=currentUser.id" disabled v-model="quotation.user_id" :items="usersLists" label="Vendedor" item-text="name" item-value="id">                
                </v-autocomplete>
            </v-col>
            <v-col cols="12" sm="6" md="2" class="pb-0 mb-0" v-if="quole=='Venta'">
                <v-checkbox v-model="quotation.bar" label="Mostrador"></v-checkbox>
            </v-col>
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text class="pb-0">
            <v-container>
                <v-row class="py-6">
                    <v-col class="pt-0" cols="12" sm="6" :md="liga!='https://backendmf.unocrm.mx/'?'4':'6'">
                        <v-autocomplete @keydown.enter="filter()" v-model="quotation.company_id" :items="companyLists" :loading="isLoadingCompany" :search-input.sync="searchCompanies" :hide-no-data="searchCompanies==''||searchCompanies==undefined||searchCompanies==null" item-value="id" item-text="name" label="Empresa" placeholder="Escribe para buscar" attach>
                            <template v-slot:item="{item, attrs, on}">
                                <v-list-item v-on="on" v-bind="attrs">
                                    <v-list-item-content>
                                        <v-list-item-title v-if="item.name!=null">
                                            <span v-if="item.macro!=null">{{item.macro}}</span>{{item.name}}
                                            <div v-if="item.razon_social!=null">
                                                <span style="font-size:12px;">{{item.razon_social}}</span>
                                            </div>
                                        </v-list-item-title>
                                        <v-list-item-title v-else-if="item.razon_social!=null">
                                            {{item.razon_social}}
                                        </v-list-item-title>
                                    </v-list-item-content>
                                </v-list-item>
                            </template> 
                            <template slot="no-data">
                                <v-row class="ma-0 py-2 px-6">
                                    <span>No existen clientes relacionados.</span>
                                    <v-spacer/>
                                    <v-btn rounded color="primary" class="elevation-0" :client_name="searchCompanies" small @click="createCompanyDialog=true">Crear</v-btn>
                                </v-row>
                            </template>    
                        </v-autocomplete>
                    </v-col>
                    <v-col class="pt-0" cols="12" sm="6" md="4" v-if="liga!='https://backendbdb.unocrm.mx/'&&liga!='https://backendmf.unocrm.mx/'">
                        <v-autocomplete @keydown.enter="filter()" v-model="quotation.contact_id" :items="contactList" :loading="isLoadingContact" :search-input.sync="searchContacts" hide-no-data item-value="id" item-text="name" label="Contacto" placeholder="Escribe para buscar" attach>
                            <template v-slot:item="{item, attrs, on}">
                                <v-list-item v-on="on" v-bind="attrs">
                                    <v-list-item-content>
                                        <v-list-item-title>
                                            {{item.name}} <span v-if="item.last!=undefined">{{item.last}}</span>
                                            <div>
                                                <span style="font-size:12px;">{{item.company}}</span>
                                            </div>
                                        </v-list-item-title>
                                    </v-list-item-content>
                                </v-list-item>
                            </template> 
                        </v-autocomplete>
                    </v-col> 
                    <v-col class="pt-0" cols="12" sm="4"  :md="liga!='https://backendmf.unocrm.mx/'?'4':'6'" v-if="liga!='https://backendbdb.unocrm.mx/'">
                        <v-autocomplete @keydown.enter="filter()" :disabled="quotation.company_id==''" v-model="quotation.company_branch_id" :items="branchesList" :loading="isLoadingBranch" :search-input.sync="searchBranch" hide-no-data item-value="id" item-text="name" :label="liga == 'https://backendmf.unocrm.mx/'?'Comedor':'Sucursal'" placeholder="Escribe para buscar" attach>
                            <template v-slot:item="{item, attrs, on}">
                                <v-list-item v-on="on" v-bind="attrs">
                                    <v-list-item-content>
                                        <v-list-item-title>
                                            {{item.name}}
                                            <div>
                                                <span style="font-size:12px;">{{item.address}}</span>
                                            </div>
                                        </v-list-item-title>
                                    </v-list-item-content>
                                </v-list-item>
                            </template> 
                        </v-autocomplete>
                    </v-col> 
                    <v-col class="pt-0" cols="12" sm="6" md="6" >
                        <v-autocomplete clearable v-model="quotation.type" :rules="[v => !!v || 'Campo requerido']" :items="series" label="Tipo de Venta">
                            <template slot="no-data" class="pa-2">No existen tipos de venta relacionados.</template>                      
                        </v-autocomplete>
                    </v-col>
                    <v-col class="pt-0" cols="12" sm="6" :md="liga!='https://backendbdb.unocrm.mx/'?'6':'4'" v-if="quole=='Venta' || quole=='Pedido'">
                        <v-menu v-model="datePicker" :close-on-content-click="false" :nudge-right="40" transition="scale-transition" offset-y min-width="290px" >
                            <template v-slot:activator="{ on }">
                                <v-text-field :rules="[v => !!v || 'Campo requerido']" clearable required v-model="quotation.date" label="Fecha Programada" prepend-icon="mdi-calendar" readonly v-on="on"></v-text-field>
                            </template>
                            <v-date-picker color="primary" v-model="quotation.date" @input="datePicker = false"></v-date-picker>
                        </v-menu>
                    </v-col>
                    <v-col class="pt-0" cols="12" sm="6" :md="liga!='https://backendmf.unocrm.mx/'&&liga!='https://backendbdb.unocrm.mx/'?'6':'4'" v-if="quole=='Cotización'">
                        <v-menu v-model="datePicker" :close-on-content-click="false" :nudge-right="40" transition="scale-transition" offset-y min-width="290px" >
                            <template v-slot:activator="{ on }">
                                <v-text-field :rules="[v => !!v || 'Campo requerido']" clearable required v-model="quotation.due_date" label="Fecha de Vencimiento" prepend-icon="mdi-calendar" readonly v-on="on"></v-text-field>
                            </template>
                            <v-date-picker color="primary" v-model="quotation.due_date" @input="datePicker = false"></v-date-picker>
                        </v-menu>
                    </v-col>
                </v-row>  
                <v-row style="background-color: #94949417;" class="px-2 ma-0 py-2" v-for="(item,k) in quotation.items" :key="k">
                    <v-col ols="12" sm ="4" md="1" class="py-0 my-0">
                        <v-text-field type=number v-model="item.quantity" label="Cantidad"></v-text-field>
                    </v-col>
                    <v-col ols="12" sm ="8" :md="liga=='https://backendmf.unocrm.mx/'?(quotation.global_discount>0?'4':'6'):'6'" class="py-0 my-0">
                        <v-autocomplete v-if="item.item==''" item-text="key" v-model="item.item" @change="item.manual_price = false" item-value="id" label="Producto" clearable :items="productsList" :loading="isLoadingProducts" :search-input.sync="searchProducts" placeholder="Escribe para buscar o crear" hide-no-data>

                            <template v-slot:item="{item, attrs, on}">
                                <v-list-item v-on="on" v-bind="attrs">
                                    <v-list-item-content>
                                        <v-list-item-title>
                                            {{item.name}} <span v-if="liga!='https://backendmf.unocrm.mx/'">| {{(item.price*1).toLocaleString('es-MX', { style: 'currency', currency: 'MXN',})}}</span>
                                            <div>
                                                <span style="font-size:14px;">Inventario:
                                                    <strong v-if="item.inventory<1" style="color:red!important;">{{item.inventory}}</strong>
                                                    <strong v-else style="color:green!important;">{{item.inventory}}</strong>
                                                </span>
                                            </div>
                                        </v-list-item-title>
                                    </v-list-item-content>
                                </v-list-item>
                            </template> 
                        </v-autocomplete>
                        <v-row v-else class="ma-0 py-3" style="border-bottom: 1px solid #8e8e8e;">{{productsList.filter(product=>product.id ==item.item).map(product=>product.name)[0]}}</v-row>
                    </v-col>
                    <v-col cols="12" sm ="8" :md="liga=='https://backendmf.unocrm.mx/'?(quotation.global_discount>0?'3':'4'):'4'" class="py-0 my-0" v-if="item.item!=''"><!--quole!='Pedido'"-->
                        <v-text-field v-model="item.price"  prefix="$" suffix="c/u" label="Precio" type="number" @input="item.manual_price = true; item.total_price = (Number(item.price||0) * Number(item.quantity||0)).toFixed(2)"></v-text-field>
                    </v-col>
                    <v-col v-if="liga=='https://backendmf.unocrm.mx/'&&quotation.global_discount>0" cols="12" sm ="8" md="3" class="py-0 my-0">
                        <v-text-field :value="item.price - ((item.price/100)*item.discount)" disabled prefix="$" suffix="c/u" label="Precio Ajustado" type="number"></v-text-field>
                    </v-col>
                    <v-col cols="12" sm ="4" md="1">
                        <v-icon v-if="editProducts" @click="remove(k)" v-show="k || ( !k && quotation.items.length > 1)" color="red">mdi-close</v-icon>
                        <v-icon :disabled="item.item==''" @click="add(k)" v-show="k == quotation.items.length-1" color="primary">mdi-plus</v-icon>
                    </v-col>
                </v-row>
                <v-row>
                    <v-spacer/>
                    <v-btn x-small text @click="editProducts=!editProducts"> Editar Productos<v-icon x-small color="grey">mdi-pencil</v-icon></v-btn>
                </v-row>
                <v-row class="mt-1 px-6">
                    <v-col cols="12" sm="6" md="6">
                        <v-container fluid v-if="liga=='https://suministros.uno/'">
                            <v-text-field v-model="quotation.note" label="Orden de Compra"></v-text-field>
                            <v-textarea v-model="quotation.internal_note" label="Nota Interna"></v-textarea>
                        </v-container>
                        <v-container fluid v-else>
                            <v-text-field v-model="quotation.purchase_order" label="Orden de Compra"></v-text-field>
                            <v-textarea v-model="quotation.note" label="Nota Interna"></v-textarea>
                        </v-container>
                    </v-col>
                    <v-col cols="12" sm="6" md="4">
                        <v-text-field v-if="liga=='https://backendmf.unocrm.mx/'" class="my-4 mb-0 pb-0" disabled v-model="quotation.subtotal" prefix="$" label="Monto en Pesos"></v-text-field>
                        <v-text-field v-if="liga=='https://backendmf.unocrm.mx/'" class="my-4 mt-0" type="number" v-model="quotation.global_discount" suffix="%" label="Descuento"></v-text-field>
                        <div v-if="liga!='https://backendmf.unocrm.mx/'">
                            <strong>IVA = {{(quotation.subtotal*.16).toLocaleString('es-MX', { style: 'currency', currency: 'MXN',})}}</strong>
                            <br>
                            <strong>Total = {{(quotation.subtotal*1.16).toLocaleString('es-MX', { style: 'currency', currency: 'MXN',})}}</strong>
                        </div>
                    </v-col>
                </v-row>
            </v-container>
        </v-card-text>
        <v-row class="ma-0 pa-0">
            <v-col cols="12" sm="12" md="6">
                <v-menu top offset-x class="hidden-md-and-down">
                    <template v-slot:activator="{ on, attrs }">
                        <v-btn :color="colorFile" style="font-size:12px;" text v-bind="attrs" v-on="on">
                            <v-icon class="mr-2">mdi-attachment</v-icon> Adjuntar archivo
                        </v-btn>
                    </template>
                    <vue-dropzone ref="myVueDropzone" id="dropzone" :options="dropzoneOptions" :useCustomSlot="true" v-on:vdropzone-success="uploadSuccess" v-on:vdropzone-error="uploadError" v-on:vdropzone-removed-file="fileRemoved"/>
                </v-menu>
            </v-col>
            <v-col cols="12" sm="12" md="6">
                <v-card-actions>
                    <v-spacer class="hidden-md-and-down"></v-spacer>

                    <v-btn color="blue darken-1" text @click="close(undefined)">
                        Cancelar
                    </v-btn>
                    <v-btn color="blue darken-1" text @click="save"  :loading="gris" :disabled="gris || todaviano">
                        Guardar
                    </v-btn>
                </v-card-actions>
            </v-col>
        </v-row>
        <!-- Crear Contacto -->
        <v-dialog v-model="createContactDialog" max-width="600px">
            <createContact v-bind:company="quotation.company_id" @closeCreateDialogContact="closeCreateDialogContact"/>
        </v-dialog>
        <!-- Crear empresa -->
        <v-dialog v-model="createCompanyDialog" max-width="700px">
          <template v-slot:activator="{ on, attrs }">
            <v-btn bottom color="#e25200" dark fab fixed right v-bind="attrs" v-on="on">
                <v-icon color="white">  mdi-plus </v-icon>
            </v-btn> 
          </template>
          <createCompany @closeCreateDialogClient="closeCreateDialogClient"/>
        </v-dialog>
        <v-snackbar :color="snackbar.color" v-model="snackbar.show">
            {{ snackbar.message }}
        </v-snackbar>
    </v-card>
</template>

<script>
import vue2Dropzone from "vue2-dropzone";
import "vue2-dropzone/dist/vue2Dropzone.min.css";
import CreateContact from "../clients/contacts/create"
import CreateCompany from "../clients/companies/create"
import axios from "axios";

export default {
    props:{
        message:Object,
        initialQuotation: { type: Object, default: null },
        mode: { type: String, default: 'create' } // 'create' | 'duplicate'
    },
    components: {
        vueDropzone: vue2Dropzone,
        'createContact':CreateContact,
        'createCompany':CreateCompany,
    },   
    data: () => ({
        editProducts:false,
        snackbar: {
            show: false,
            message: null,
            color: null
        },
        colorFile: 'black',
        gris:false,
        company:'',
        status:'',
        datePicker:'',
        datePicker2:'',
        createContactDialog: false,
        createCompanyDialog: false,
        dropzoneOptions: {
            url: process.env.VUE_APP_BACKEND_ROUTE + "api/v1/quotation/files",
            addRemoveLinks: true,
            maxFiles: 1
        },
        series:['Serie A',  'Serie B'],
        quotation:{
            global_discount:0,
            company_id:null,
            contact_id:'',
            user_id:'',
            pdf:'',
            note:'',
            items:[{
                quantity:process.env.VUE_APP_BACKEND_ROUTE=='https://backendmf.unocrm.mx/'?'':1,
                item:'',
                price:'',
                discount:0,
                manual_price:false,
                cost:0
            }],
            bar:0,
            status:'quotation',
            subtotal:'',
            date:'',
            type:process.env.VUE_APP_BACKEND_ROUTE=='https://backendmf.unocrm.mx/'?'CEDIS':'Serie A',
            iva:'',
            total:'',
            invoice:'',
            printed:'',
            created_by_user_id:'',
            last_updated_by_user_id:'',
            invoice_date:'',
            due_date:'',
            company_branch_id:'',
            internal_note:''
        },
        rules: {
            required: value => !!value || 'Campo requerido',
        },
        valid: true,
        entries:{
            products: [],
            companies: [],
            contacts:[],
            branches:[]
        },
        isLoadingProducts: false,
        searchProducts: null,
        client_percentage:0,
        isLoadingCompany: false,
        isLoadingContact: false,
        searchCompanies: null,
        searchContacts: null,
        searchBranch: null,
        isLoadingBranch:null
    }),
    computed: {
        globalDiscount(){
            return this.quotation.global_discount
        },
        productTotal(){
            return this.quotation.items
        },
        companyPercentage(){
            return this.quotation.company_id
        },
        liga(){
            return process.env.VUE_APP_BACKEND_ROUTE
        },
        todaviano(){
            if(this.quotation.company_id!=null&&(this.quotation.type!=''||this.liga=='https://backendmf.unocrm.mx/')){
                if((this.quole=='Venta'||this.quole=='Pedido')&&this.quotation.date!=''){
                    for(var i=0; i<this.quotation.items.length; i++){
                        if(this.quotation.items[i].item!=''||this.quotation.items[i].item!=null||this.quotation.items[i].item!=undefined){
                            if(this.quotation.items[i].price==''||this.quotation.items[i].price==null||this.quotation.items[i].price==undefined||this.quotation.items[i].price<0.01){
                                return true
                            }
                        }else{
                            
                        }
                    }
                    return false
                }else if(this.quole=='Cotización'&&this.quotation.due_date!=''){
                    for(var i=0; i<this.quotation.items.length; i++){
                        if(this.quotation.items[i].item!=''||this.quotation.items[i].item!=null||this.quotation.items[i].item!=undefined){
                            if(this.quotation.items[i].price==''||this.quotation.items[i].price==null||this.quotation.items[i].price==undefined||this.quotation.items[i].price<0.01){
                                return true
                            }
                        }else{
                            
                        }
                    }
                    return false
                }else{
                    return true
                }
            }else{
                return true
            }
        },
        companyLists(){
            return this.entries.companies.map(id => {
                return{
                    id:id.id,
                    macro:id.attributes.macro,
                    name:id.attributes.name,
                    razon_social:id.attributes.razon_social,
                    price_list:id.attributes.price_list
                }
            })
        },
        contactList(){
            return this.entries.contacts.map(id => {
                return{
                    id:id.id,
                    name:id.name,
                    last:id.last,
                    company:id.company.name,
                    job_position:id.job_position
                }
            })
        }, 
        branchesList(){
            return this.entries.branches
        },
        usersLists(){
            return this.$store.getters['user/activeUsers'];
        },
        productsList(){
            var perro = this.entries.products.map(id=>{return{
                ...id,
                inventory:id.branch_inventories[this.currentUser.branch[0].name],
                key: id.name + ' ' + id.code_one
            }})
            return perro
        },
        totalQuotation(){
            var total=0
            if(this.quotation.items.length!=0){
                for(var i=0; i<this.quotation.items.length; i++){
                    if(this.quotation.items[i].price!=undefined){
                        total = total+(this.quotation.items[i].price*this.quotation.items[i].quantity)
                    }
                }
                return total
            }
        }, 
        currentUser:{
            get(){
                return this.$store.state.currentUser.user
            }
        },
        quole(){
            if(this.status=='vendido'){
                return 'Venta'
            }else if(this.status=='quotation'){
                return 'Cotización'
            }else if(this.status=='pedido'){
                return 'Pedido'
            } 
        } 
    },
    created() {
        this.company = this.message[0]
        this.status  = this.message[1]
        if (this.initialQuotation) {
            this.quotation = Object.assign({}, this.quotation, this.initialQuotation)
            if (this.initialQuotation._entries) {
                this.entries.companies = this.initialQuotation._entries.companies || []
                this.entries.branches  = this.initialQuotation._entries.company_branches || []
                this.entries.contacts  = this.initialQuotation._entries.contacts || []
                this.entries.products  = this.initialQuotation._entries.products || []
            }
            if (!this.quotation.user_id) this.quotation.user_id = this.currentUser.id

        } else {
            if (this.company != undefined) {
                this.quotation.company_id = Number(this.company)
            }
            if (this.$route.params.id != undefined) {
                axios.get(process.env.VUE_APP_BACKEND_ROUTE + 'api/v2/companies?filter[id]=' + this.$route.params.id)
                .then(res => {
                    this.entries.companies   = res.data.data
                    this.quotation.company_id = this.$route.params.id
                })
            }
        }
        },
    methods: {
        permissions(permission){
            if(this.currentUser.id==1){
                return true
            }else if(this.currentUser.permissions!=undefined){
                if(this.currentUser.permissions.includes(permission)){
                    return true
                }else{
                    return false
                }
            }else{
                return false
            }
        },
        uploadSuccess(file, response) {
            console.log('File Successfully Uploaded with file name: ' + response.file);
            this.fileName = response.file;
            this.quotation.pdf = this.fileName;
            this.colorFile = 'success'
        },
        uploadError(file, message) {
                this.snackbar = {
                    message: 'No se pudo cargar el archivo',
                    color: 'error',
                    show: true
                }
                this.colorFile = 'error'
            },
        fileRemoved() {
            
        },
        sugestedValue(id) {
            return this.productsList.filter(item => item.id == id).map(item => item.price)[0];
        },
        add(index) {
            this.quotation.items.push({ quantity: this.liga=='https://backendmf.unocrm.mx/'?'':1, item: '', price:'', discount: this.quotation.global_discount, manual_price:false });
        },
        remove(index) {
            this.quotation.items.splice(index, 1);
        },
        close (quotation) {
            this.gris = false
            this.quotation = {
                global_discount:0,
                company_id:null,
                contact_id:'',
                user_id:'',
                pdf:'',
                note:'',
                items:[{
                    quantity:process.env.VUE_APP_BACKEND_ROUTE=='https://backendmf.unocrm.mx/'?'':1,
                    item:'',
                    price:'',
                    discount:0,
                    manual_price:false,
                    cost:0
                }],
                bar:0,
                status:'quotation',
                subtotal:'',
                date:'',
                type:process.env.VUE_APP_BACKEND_ROUTE=='https://backendmf.unocrm.mx/'?'CEDIS':'Serie A',
                iva:'',
                total:'',
                invoice:'',
                printed:'',
                created_by_user_id:'',
                last_updated_by_user_id:'',
                invoice_date:'',
                due_date:'',
                company_branch_id:'',
                internal_note:''
            },
            this.$nextTick(() => {
                this.$emit("closeCreateDialogQuotation", quotation);
            })
        },
        save(){
            console.log(this.quotation)
            if(this.quotation.user_id==''||this.quotation.user_id==undefined||this.quotation.user_id==null){
                this.quotation.user_id=this.currentUser.id
            }
            if(this.quotation.bar){
                this.quotation.bar = 1
            }else{
                this.quotation.bar = 0
            }
            this.gris = true
            this.quotation.created_by_user_id = this.currentUser.id
            this.quotation.last_updated_by_user_id = this.currentUser.id
            if(this.quotation.type == 'Serie A'){
                this.quotation.iva = this.quotation.subtotal*.16
                this.quotation.total = this.quotation.subtotal*1.16
            }else if(this.quotation.type == 'Serie B'){
                this.quotation.iva = this.quotation.subtotal*.16
                this.quotation.total = this.quotation.subtotal*1.16
            }
            if(this.liga=='https://backendmf.unocrm.mx/'){
                if(this.quotation.type == 'Serie A'){
                    this.quotation.type = 'CEDIS'
                }
                this.quotation.iva = 0
                this.quotation.total = this.quotation.subtotal
            }
            this.quotation.status = this.status
            const quotation_to_save = [this.quotation].map(q=>{return{
                ...q,
                items:q.items.map(qi=>{return{
                    ...qi,
                    price: qi.price - ((qi.price/100)*qi.discount),
                    discount:qi.discount*1,
                }})
            }})[0]
            console.log(quotation_to_save)
            this.$nextTick(() => {
                axios.post(process.env.VUE_APP_BACKEND_ROUTE + "api/v2/sales",Object.assign(quotation_to_save)).then(response=>{
                    //this.$store.dispatch('quotation/getQuotations')
                    this.$nextTick(() => {
                        this.close(response.data.data)
                    })
                }).catch(error => {
                    this.snackbar = {
                        message: error.response.data.message,
                        color: 'error',
                        show: true
                    }
                    this.gris = false
                })
            })
        },
        closeCreateDialogContact: function(params) {
            this.createContactDialog = false;
            this.$store.dispatch('contact/getContacts')
        },
        closeCreateDialogClient: function(params) {
            this.createCompanyDialog = params;
            this.$store.dispatch('company/getCompanies')
        },
        roundPesos(n){ return Math.round(n); },
    },
    watch:{
        message:{
            handler(){
                if(this.$route.params.id!=undefined){
                    axios.get(process.env.VUE_APP_BACKEND_ROUTE + 'api/v2/companies?filter[id]='+this.$route.params.id)
                    .then(res => {
                        this.entries.companies = res.data.data
                        this.quotation.company_id = this.$route.params.id
                    })
                }
            }, deep:true
        },
        globalDiscount:{
            handler(){
                for(var i=0; i<this.quotation.items.length; i++){
                    this.quotation.items[i].discount = this.quotation.global_discount
                }
            }, deep:true
        },
        companyPercentage:{
            handler(){
                if (this.liga === 'https://backendmf.unocrm.mx/') {
                const clientPct =
                    Number(this.companyLists.find(c => c.id === this.quotation.company_id)
                        ?.price_list?.name?.replace('%','')) || 0;
                this.client_percentage = clientPct;

                for (const it of this.quotation.items) {
                    if (!it.item) continue;
                    const qty  = Number(it.quantity) || 0;
                    const cost = Number(this.productsList.find(p => p.id === it.item)?.cost) || 0;

                    if (!it.manual_price) {
                    it.price = this.roundPesos(cost / (1 - clientPct/100)).toFixed(2);
                    }
                    it.total_price = ((Number(it.price) || 0) * qty).toFixed(2);
                    it.cost = cost
                }
                }
            },
            deep:true
        },

        productTotal:{
            handler(){
                if (this.liga === 'https://backendmf.unocrm.mx/') {
                const clientPct = Number(this.client_percentage) || 0;

                for (const it of this.quotation.items) {
                    if (!it.item) continue;
                    const qty  = Number(it.quantity) || 0;
                    const cost = Number(this.productsList.find(p => p.id === it.item)?.cost) || 0;

                    if (!it.manual_price) {
                    it.price = this.roundPesos(cost / (1 - clientPct/100)).toFixed(2);
                    }
                    it.total_price = ((Number(it.price) || 0) * qty).toFixed(2);
                    it.cost = cost
                }
                }
            },
            deep:true
        },
        searchProducts(val){
            if (this.isLoadingProducts) return
            this.isLoadingProducts = true
            const publishedFilter = this.quole === 'Cotización' ? '' : '&filter[is_published]=1';
            axios.get(process.env.VUE_APP_BACKEND_ROUTE + 'api/v2/item/pos?filter[pos]='+encodeURIComponent(val || '')+publishedFilter)
            .then(res => {
                this.entries.products = this.entries.products.concat(res.data.data)
            }).finally(() => (this.isLoadingProducts = false, this.search = false))
        },
        searchCompanies(val){
            if(val!=undefined&&val!=null){
                if (this.isLoadingCompany) return
                this.isLoadingCompany = true
                axios.get(process.env.VUE_APP_BACKEND_ROUTE + 'api/v2/companies?filter[name_razon_social]='+val)
                .then(res => {
                    this.entries.companies = res.data.data
                }).finally(() => (this.isLoadingCompany = false))
            }
        },
        searchContacts(val){
            if (this.isLoadingContact) return
            this.isLoadingContact = true
            var length = this.quotation.company_id.length
            if(length>0){
                var filter = 'filter[company_id]='
                for(var i=0; i<length; i++){
                    filter = filter + this.quotation.company_id[i]
                }
            }else{
                var filter = ''
            }
            axios.get(process.env.VUE_APP_BACKEND_ROUTE + 'api/v2/contact_p?' + filter + "filter[name]=" + val)
            .then(res => {
                if(this.entries.contacts.length>0){
                    this.entries.contacts.concat(res.data.data)
                }else{
                    this.entries.contacts = res.data.data
                }
            }).finally(() => (this.isLoadingContact = false))
        },
        searchBranch(val){
            if (this.isLoadingBranch) return
            this.isLoadingBranch = true
            axios.get(process.env.VUE_APP_BACKEND_ROUTE + 'api/v2/company_branches?filter[company_id]=' + this.quotation.company_id + "&filter[name]=" + val)
            .then(res => {
                this.entries.branches = res.data.data
            }).finally(() => (this.isLoadingBranch = false))
        },
        totalQuotation:{
            handler(){
                this.quotation.subtotal=this.totalQuotation
            }, deep: true
        },
    }
}
</script>
<style lang="css" scoped>
.v-text-field >>> label{
    font-size: 14px!important;
}
</style>
<style>
.v-input__icon--prepend-inner i::before {
    font-size: 18px!important;
    color:#1976D2;
}
.v-text-field input, .v-label {
    font-size: 14px;
}
.v-picker__title.primary{
    display:none;
}
</style>
